import React, { useEffect, useState, useMemo, useRef, createContext, useContext } from 'react';
import Button from '../../components/Button/Button';
import './HalfPageBreif.css'
import NoResultsComponent from '../../components/NoResults/NoResult';
import Loader from '../../components/Loader/Loader';
import axios from '../../services/axiosInstance';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { fetchHalfPageBreif, fetchByfilter, fetchChannelsByClusterID } from '../../services/api';
import { fetchFilterByCretedBy } from "../../services/dashboardAPI";
import DropdownList from '../DropdownList/DropdownList';
import { fetchAPI, fetchCommisionEditors, smEvaluationProposalData } from '../../services/api';
import { AssignProposalHalfPage } from './AssignProposal';
import ProposalDetails from '../../components/HalfPageComponents/ProposalDetails';
import Halfpageheader from '../../components/HalfPageComponents/HalfPageHeader';
import { formatclusterandroleName, formatDate, getFieldKeys, swapObject } from '../../util/util';
import CryptoUtils from '../../util/cryptoUtils';
import DownloadDocPdf from '../../components/DownloadDocPdf/DownloadDocPdf';
import CEEvalViewAccordion from '../../components/CEEvalViewAccordion/CEEvalViewAccordion';
import CEEvalStatusToolTip from '../ToolTip/CEEvalStatusTooltip';
import infoIcon from '../../assets/images/icons/information-line.svg';
import { useDispatch } from 'react-redux';
import { setUSPDetails } from '../../pages/Login/LoginSlice';
import { useLanguage } from '../../context/Languagecontext';
import { Globals as OldGlobals } from '../../global/Globals';
const ProposalContext = createContext();
export default function ProposalHalfUnsolicated(props) {
  const { Globals, languages, setLanguages } = useLanguage();
  const { onClose, item, proposalDetailIdVal, popupShow, refreshDashboard, renderToast, isAuditTrail = false, page } = props
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem('isFromProducerPage', false);
  const isProducerViewed = JSON.parse(localStorage.getItem('isProducerViewed'));
  const [contentDataStatus, setContentDataStatus] = useState(null)
  const [proposalCount, setProposalCount] = useState([]);
  const [activeTab, setActiveTab] = useState("All");
  const [activeTimeTab, setActivetimetab] = useState("OneMonth");
  const [isSynopsisExpanded, setIsSynopsisExpanded] = useState(false);
  const [isLogLineExpanded, setIsLogLineExpanded] = useState(false);
  const [isepisodeStructureExpanded, setEpisodeStructureExpanded] = useState(false);
  const [iskeyTeamsExpanded, setKeyTeamsExpanded] = useState(false);
  const [isprojectStatusExpanded, setProjectStatusExpanded] = useState(false);
  const [isbrandIntegrationExpanded, setBrandIntegrationExpanded] = useState(false);
  const [iscastPresenterInfoExpanded, setCastPresenterInfoExpanded] = useState(false);
  const [islocationStudioInfoExpanded, setLocationStudioInfoExpanded] = useState(false);
  const [brefNo, setBRefNo] = useState([]);
  const [proposalData, setProposalData] = useState(null);
  const [proposalError, setProposalError] = useState(null);
  const [proposalType, setProposalType] = useState(0);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [submissionRequirements, setSubmissionRequirements] = useState("");
  const [evalAndSelection, setEvalAndSelection] = useState("");
  const [formatName, setFormatName] = useState("");
  const [languageName, setLanguageName] = useState("");
  const [countryName, setCountryName] = useState("");
  const [channelName, setChannelName] = useState("");
  const [contentName, setContentName] = useState("");
  const [genreName, setGenreName] = useState("");
  const [clusterName, setClusterName] = useState("");
  const [productionTypeName, setProductionTypeName] = useState("");
  const [closingDate, setClosingDate] = useState(new Date().toISOString());
  const [briefStatus, setBriefStatus] = useState(0);
  const [proposalDetailId, setProposalDetailId] = useState(0);
  const [producerId, setProducerId] = useState("3fa85f64-5717-4562-b3fc-2c963f66afa6");
  const [propRefNo, setPropRefNo] = useState("");
  const [logLine, setLogLine] = useState("");
  const [synopsis, setSynopsis] = useState("");
  const [noOfEpisodes, setNoOfEpisodes] = useState(0);
  const [episodeDuration, setEpisodeDuration] = useState(0);
  const [targetAudienceName, setTargetAudienceName] = useState("");
  const [episodeStructure, setEpisodeStructure] = useState("");
  const [castPresenterInfo, setCastPresenterInfo] = useState("");
  const [locationStudioInfo, setLocationStudioInfo] = useState("");
  const [brandIntegration, setBrandIntegration] = useState("");
  const [keyTeams, setKeyTeams] = useState("");
  const [productionTimeLine, setProductionTimeLine] = useState("");
  const [artistName, setArtistName] = useState("");
  const [songName, setSongName] = useState("");
  const [targetBudget, setTargetBudget] = useState(0);
  const [currency, setCurrency] = useState("");
  const [status, setStatus] = useState(0);
  const [projectStatus, setProjectStatus] = useState("");
  const [referenceLinks, setReferenceLinks] = useState("");
  const [submissionDate, setSubmissionDate] = useState(new Date().toISOString());
  const [fileItems, setFileItems] = useState([]);
  const [ceEvalDetails, setCEEvalDetails] = useState(null);
  const [isUnsuccessfulMailSent, setIsUnsuccessFulMailSent] = useState(false);
  const [proposalStatusHistories, setProposalStatusHistories] = useState([
    {
      proposalStatusHistoryId: 0,
      currentStatus: 0,
      changedAt: new Date().toISOString(),
      userComment: ""
    }
  ]);
  const [roleID, setroldId] = useState(CryptoUtils.getFromLocalStorage("roleId").toString());
  const [cluster, setCluster] = useState([]);
  const [BreifData, setBreifData] = useState([])
  const [clusterList, setClustersList] = useState()
  const [channelList, setChannelList] = useState()
  const [contentData, setContentData] = useState([])
  const [data, setData] = useState([]);
  const proposalId = item.proposalId;
  const proposalDetailIdValue = item?.proposalDetailId;
  const [channelsArray, setChannelsArray] = useState([]);
  const [selectedClusterID, setSelectedCLusterID] = useState("");
  const [selectedChannelID, setSelectedChannelID] = useState("");
  const [smName, setSMName] = useState('');
  const clusterValue = BreifData[9];
  const [hideMainLayout, setHideMainLayout] = useState(false);
  const [hidehalfscreen, sethideHalfscreen] = useState(false);
  const [isClusterChannelVisible, setClusterChannelVisible] = useState(false);
  const [halfPageData, setHalfPageData] = useState();
  const [clusterError, setErrorCluster] = useState({ error: '', msg: '' });
  const [channelError, setChannelError] = useState({ error: '', msg: '' });
  const reAssignBriefBody = { proposalDetailId: proposalDetailIdValue, proposalId: proposalId?.toString(), clusterId: selectedClusterID, channelId: selectedChannelID }
  const [selectedChannelName, setSelectedChannelName] = useState("");
  const [isReAssignBtnDisabled, setReAssignBtnDisabled] = useState(true);
  const [btnClassName, setBtnClassName] = useState('disabled-apply-btn');
  const proposalBody = { proposalDetailId: halfPageData?.proposalDetailId?.toString(), proposalId: halfPageData?.proposalId, status: halfPageData?.evalStatus }
  const [clusteredCEList, setClusteredCEList] = useState(null);
  const [existingCEList, setExistingCEList] = useState(null);
  const [ceEvalAPIFailure, setCEEvalAPIFailure] = useState(false);
  const [isSMRoleAvailableInCluster, setIsSMRoleAvailableInCluster]=useState(false);
  const [isHOPRoleAvailableInCluster, setIsHOPRoleAvailableInCluster]=useState(false);
  const [isUnsuccessfulAfterSM, setIsUnsuccessfulAfterSM]=useState(false);
  const getClustersData = async () => {
    try {
      const result = await fetchByfilter(
        OldGlobals.FILTER_OPTIONS_NAME.CLUSTERS
      );
      setClustersList(result.data.content.Clusters);
    } catch (error) {
      console.error("Error in App component:", error);
      setContentDataStatus("Error");
    }
  }


  const getSMDetails = async (clusterId) => {
    try {
      const result = await fetchFilterByCretedBy(
        roleID, clusterId
      );
      const name = result.data.content[0].name;
      setSMName(name);
    } catch (error) {
      console.error("Error in App component:", error);
      setContentDataStatus("Error");
    }
  }
  const handleClustersList = (event) => {
    const clusterId = clusterList.find(item => item.name === event).id;
    setSelectedCLusterID(clusterId);
    clusterError.error = false;
    clusterError.msg = "";
    setErrorCluster(clusterError)
    setSelectedChannelID('');
    setReAssignBtnDisabled(true)
    getChannelsList(clusterId);
    getSMDetails(clusterId)
    setBtnClassName("disabled-apply-btn")

  }


  useEffect(() => {
    getClustersData();

  }, []);

  const handleBackPress = () => {
    setHideMainLayout(false)
    setClusterChannelVisible(false);
    setSelectedCLusterID('');
    setSelectedChannelID('');
    setBtnClassName("disabled-apply-btn")
    setReAssignBtnDisabled(true)
  }
  const getChannelsList = async (clusterId) => {
    try {
      const result = await fetchChannelsByClusterID(
        clusterId
      );
      setChannelList(result.data.content);
      if (result.data.content.length > 0) {
        setClusterChannelVisible(true);
      }


    } catch (error) {
      console.error("Error in App component:", error);
      setContentDataStatus("Error");
    }
  }
  useEffect(() => {
    if (clusterList?.length > 0) {
      const arry = clusterList?.map((item) => item.name);
      setCluster(arry);
    }

    if (channelList?.length) {
      const arry = channelList
        .filter((item) =>
          selectedClusterID === memoizedCluster?.clusterId    //checking same clusterid selcted or not
            ? item.channelName !== halfPageData.channelName   //removing same channel from list if user selected same cluster
            : true
        )
        .map((item) => item.channelName);
      setChannelsArray(arry);
    }
  }, [clusterList, channelList]);


  const handleChannelList = (event) => {
    const channelId = channelList.find(item => item.channelName === event).channelId;
    setSelectedChannelID(channelId);
    channelError.error = false;
    channelError.msg = "";
    setChannelError(channelError)
    setSelectedChannelName(event);
    setReAssignBtnDisabled(false)
    setBtnClassName("reassign-btn-active1")


  }
  const [activeIndexes, setActiveIndexes] = useState({});

  const handleToggle = (category, index) => {
    setActiveIndexes(prevState => ({
      ...prevState,
      [category]: {
        ...prevState[category],
        [index]: !prevState[category]?.[index]
      }
    }));
  };


  const openPopUp = (popUpType = "Submit", updateFlag = false, smRoleName = "") => {
    if (popUpType === "Submit") {
      if (selectedClusterID === '') {
        const newClusterError = { ...clusterError, error: true, msg: Globals.HALF_PAGE_BRIEF_DETAILS.CLUSTER_ERROR };
        setErrorCluster(newClusterError);
      } else if (selectedChannelID === '') {
        const newChannelError = { ...channelError, error: true, msg: Globals.HALF_PAGE_BRIEF_DETAILS.CHANNEL_ERROR };
        setChannelError(newChannelError);
      } else {
        sethideHalfscreen(true);
        onClose()
        popupShow.openPopup({
          isNewAcceptanceMail: false,
          newRejection: false,
          open: true,
          comments: true,
          title: Globals.HALF_PAGE_BRIEF_DETAILS.RE_ASSIGN_PROPOSAL,
          promptText: Globals.HALF_PAGE_BRIEF_DETAILS.RE_ASSIGN_PROPOSAL_POP_UP_DESC1 + smRoleName + Globals.HALF_PAGE_BRIEF_DETAILS.RE_ASSIGN_PROPOSAL_POP_UP_DESC2,
          customClassName: 'email-popup-content',
          normalActionText: Globals.HALF_PAGE_BRIEF_DETAILS.RE_ASSIGN_PROPOSAL,
          textAreaStyle: 'CommentsInputStyle',
          textAreaTitle: Globals.HALF_PAGE_BRIEF_DETAILS.COMMENTS,
          toastMessage: Globals.HALF_PAGE_BRIEF_DETAILS.REASSIGN_PROPOSAL_TOAST_SUCCESS,
          body: reAssignBriefBody
        })

      }
      return;
    }
  };

  const fetchCEEvalDetails = async () => {
    const proposalId = item.proposalId;
    const proposalDeatilId = item.proposalDetailId;
    try {
      const response = await smEvaluationProposalData(proposalDeatilId, proposalId);
      setCEEvalDetails(response?.data?.content);
    }
    catch (error) {
      setCEEvalAPIFailure(true);
      console.error("Error in fetching CE evaluation details for unsolicited halfscreens :", error);
    }
  }

  const fetchProposalHalfPageUnsolicated = async () => {
    const proposalId = item.proposalId;
    const producerProposalDeatilId = item.proposalDetailId;
    try {
      let endPoint;
      if (roleID === '5') {
        endPoint = `${Globals.BASE_URL}/UnSolicited/GetUnSolicitedMinDisplayProposalByIdWithLifeCycleAsync?proposalId=${proposalId}&roleId=${CryptoUtils.getFromLocalStorage('roleId')}&proposalDetailId=${producerProposalDeatilId}`;
      }
      else if (roleID === OldGlobals.USER_ROLES.CC) {
        endPoint = `${Globals.BASE_URL}${Globals.ENDPOINT.CC_UNSOLICITED_HALF_SCREEN}proposalId=${proposalId}&roleId=${CryptoUtils.getFromLocalStorage('roleId')}&proposalDetailId=${proposalDetailIdVal}`
      }
      else if (roleID === OldGlobals.USER_ROLES.CE || roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID === "1" || roleID === OldGlobals.USER_ROLES.HOP) {
        endPoint = `${Globals.BASE_URL}${Globals.ENDPOINT.CE_UNSOLICITED_HALF_SCREEN}proposalId=${proposalId}&roleId=${CryptoUtils.getFromLocalStorage('roleId')}&proposalDetailId=${proposalDetailIdVal}`
      }
      const response = await axios.get(endPoint);
      const {
        createdByName,
        countryName,
        productionTypeName,
        channelName,
        formatName,
        languageName,
        genreName,
        contentTypeName,
        clusterName,
        description,
        submissionRequirements,
        evalAndSelection,
        closingDate,
        region,
        commisioningEditors,
      } = response?.data?.content;
      console.log("response --> ", response);
      setHalfPageData(response?.data?.content);
      setClusteredCEList(response?.data?.content?.commisioningEditorsListByCluster);
      setExistingCEList(response?.data?.content?.commisioningEditors);
      setIsSMRoleAvailableInCluster(response?.data?.content?.isSMRoleInCluster);
      setIsHOPRoleAvailableInCluster(response?.data?.content?.isHOPRoleInCluster);
      setIsUnsuccessfulAfterSM(response?.data?.content?.isUnSuccefullAfterSMReview);
      setContentData([
        { Description: description },
        { "Submission Requirements": submissionRequirements },
        { "Evaluation Process": evalAndSelection },
      ]);
      const commissionEditors = commisioningEditors?.join(",");
      setBreifData([
        { name: Globals.FILTER.CREATEDBY, description: createdByName },
        { name: Globals.APPLY_BRIEF.CLOSING_DATE, description: formatDate(closingDate) },
        { name: Globals.APPLY_BRIEF.CHANNEL, description: channelName },
        { name: Globals.APPLY_BRIEF.FORMAT, description: formatName },
        { name: Globals.APPLY_BRIEF.COUNTRY, description: countryName },
        { name: Globals.APPLY_BRIEF.PRODUCTION_TYPE, description: productionTypeName },
        { name: Globals.APPLY_BRIEF.SCRIPT, description: contentTypeName },
        { name: Globals.APPLY_BRIEF.GENRE, description: genreName },
        { name: Globals.APPLY_BRIEF.LANGUAGE, description: languageName },
        { name: Globals.FILTER_OPTIONS_NAME.CLUSTERS, description: clusterName },
        { name: Globals.HALFSCREEN.CE_LABEL, description: commissionEditors }
      ])
      setData([response?.data?.content]);
      return response
    } catch (error) {
      setContentDataStatus("Error");
    }
  };

  const navigateToPage = () => {

    if (roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID === OldGlobals.USER_ROLES.HOP) {
      {console.log("saasas====>",data?.[0].isVirtualPitchCompleted)}
      navigate(Globals.NAVPATH.SENIOR_MANAGER_EVALUATION_PAGE, {
        state: { activeHeader: item, selectedProposal: 'unSolicited', isVirtualPitchCompleted: data?.[0].isVirtualPitchCompleted },
      });
    } else {
      navigate(Globals.NAVPATH.REVIEW_PROPOSALS, {
        state: {
          selectedProposal: 'unSolicited',
          proposalId: item?.proposalId,
          proposalDetailId: proposalDetailIdVal
        },
      });
    }
  }

  useEffect(() => {
    const fetchProposalData = async () => {
      const proposalId = item.proposalId;
      const proposalDetailedId = item.proposalDetailedId;
      try {
        const response = await fetchProposalHalfPageUnsolicated();
        if (response?.status >= 200 && response?.status < 294) {
          setProposalData(Array.isArray(response?.data?.content) ? response?.data?.content : [response?.data?.content]);
          console.log("response?.data?.content.evalStatus",response?.data?.content?.evalStatus);
          //fix for app-dynamics, this is to call API to get CE eval only when eval status >= 2
          if (response?.data?.content?.evalStatus >= 2 && response?.data?.content?.evalStatus !== 10) {
            fetchCEEvalDetails();
          }
        } else {
          (new Error(`API returned an error: ${response?.status}`));
        }
        if (response?.data && response?.data?.content) {
          const content = response.data.content;
          setArtistName(content.artistName || "");
          setSongName(content.songName || "");
          setBRefNo(content.bRefNo || "");
          setProposalType(content.proposalType || 0);
          setTitle(content.title || "");
          setDescription(content.description || "");
          setSubmissionRequirements(content.submissionRequirements || "");
          setEvalAndSelection(content.evalAndSelection || "");
          setFormatName(content.formatName || "");
          setLanguageName(content.languageName || "");
          setCountryName(content.countryName || "");
          setChannelName(content.channelName || "");
          setContentName(content.contentName || "");
          setGenreName(content.genreName || "");
          setClusterName(content.clusterName || "");
          setProductionTypeName(content.productionTypeName || "");
          setClosingDate(content.closingDate || new Date().toISOString());
          setBriefStatus(content.briefStatus || 0);
          setProposalDetailId(content.proposalDetailId || 0);
          setPropRefNo(content.propRefNo || "");
          setLogLine(content.logLine || "");
          setSynopsis(content.synopsis || "");
          setNoOfEpisodes(content.noOfEpisodes || 0);
          setEpisodeDuration(content.episodeDuration || 0);
          setTargetAudienceName(content.targetAudienceName || "");
          setEpisodeStructure(content.episodeStructure || "");
          setCastPresenterInfo(content.castPresenterInfo || "");
          setLocationStudioInfo(content.locationStudioInfo || "");
          setBrandIntegration(content.brandIntegration || "");
          setKeyTeams(content.keyTeams || "");
          setProductionTimeLine(content.productionTimeLine || "");
          setTargetBudget(content.targetBudget || 0);
          setCurrency(content.currency || "");
          setStatus(content.status || 0);
          setProjectStatus(content.projectStatus || "");
          setReferenceLinks(content.referenceLinks || "");
          setSubmissionDate(content.submissionDate || new Date().toISOString());
          setIsUnsuccessFulMailSent(content?.isUnsuccessfulMailSent);
          if (content.proposalStatusHistories && Array.isArray(content.proposalStatusHistories)) {
            setProposalStatusHistories(content.proposalStatusHistories);
          }
          if (content && content.documents) {
            const allDocs = content.documents;
            const orderedItems = [];
            const desiredOrder = ["PSH", "VP"];
            desiredOrder.forEach(docFor => {
              const foundDoc = allDocs.find(doc => doc.documentFor === docFor);
              let heading = "";
              switch (docFor) {
                case "PSH":
                  heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.PRSCH;
                  break;
                case "VP":
                  heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.VP;
                  break;
                default:
                  heading = foundDoc?.documentType || Globals.HALFSCREEN.DOCUMENT;
              }
              orderedItems.push({ foundDoc, docFor, heading, isDownload: false });
            });
            setFileItems(orderedItems);
          } else {
            setFileItems([]);
          }
        }
      } catch (error) {
        console.log("contentDataStatus", contentDataStatus)

        setContentDataStatus("Error");
        console.error("Error fetching proposal data:", error);
      }
    };

    fetchProposalData();
  }, []);




  const toggleSynopsis = () => {
    setIsSynopsisExpanded(!isSynopsisExpanded);
  };

  const toggleLogLine = () => {
    setIsLogLineExpanded(!isLogLineExpanded);
  };

  const toggleEpisode = () => {
    setEpisodeStructureExpanded(!isepisodeStructureExpanded);
  };
  const toggleKeyteam = () => {
    setKeyTeamsExpanded(!iskeyTeamsExpanded);
  };
  const toggleProjectStatus = () => {
    setProjectStatusExpanded(!isprojectStatusExpanded);
  };
  const toggleBrand = () => {
    setBrandIntegrationExpanded(!isbrandIntegrationExpanded);
  };
  const toggleCast = () => {
    setCastPresenterInfoExpanded(!iscastPresenterInfoExpanded);
  };
  const toggleLocation = () => {
    setLocationStudioInfoExpanded(!islocationStudioInfoExpanded);
  };

  const statusImg = (statusCode) => {
    //
    const Title = statusLabels[statusCode];
    if (!Title) {
      return null;
    }
    let title;
    //if(languages==="en"){
    title = Title?.toUpperCase().replace(/[- ]/g, "");
    //}
    console.log("Status title ===> ", Title);
    //console.log("Globals : ", Globals.TRANS_IMG_NAMES);
    const swappedObject = swapObject(Globals.SUMMARY_CARD_NAME);
    // console.log("Swapped Obj ===> ",swappedObject);
    const imgKey = swappedObject[Title] || OldGlobals.IMG[title];
    console.log("imgKey ===> ", imgKey);
    const ky = imgKey?.toUpperCase();
    const imgPath = OldGlobals.IMG[ky];
    return imgPath;
  };

  // Setting status flow for producer , cc and ce.
  const statusFlow = () => {
    switch (roleID) {
      case OldGlobals.USER_ROLES.PRODUCER:
        return Globals.TIMELINE_STATUS.PRODUCER;
      case OldGlobals.USER_ROLES.CC:
        return Globals.TIMELINE_STATUS.CC;
      case OldGlobals.USER_ROLES.CE:
        return Globals.TIMELINE_STATUS.CE;
      case OldGlobals.USER_ROLES.SNR_MGR:
        return Globals.TIMELINE_STATUS.SM;
      case OldGlobals.USER_ROLES.SA:
        return Globals.TIMELINE_STATUS.SA;
      case OldGlobals.USER_ROLES.HOP:
        return Globals.TIMELINE_STATUS.HOP;
      default:
        return {};
    }
  }
  const statusLabels = statusFlow();

  const findKeyByValue = (value) => {
    console.log("val inside findKeyByValue ===> ", value);
    return Object.keys(statusLabels).find(key => statusLabels[key] === value);
  };

  const currentStatus = proposalStatusHistories?.[0]?.currentStatus ?? 0;
  const isApplyButtonDisabled = currentStatus !== 3;
  const proposalStatus = proposalData?.[0]?.proposalStatusHistories
    .sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt))[0]?.status;

  const latestComment = proposalData?.[0]?.proposalStatusHistories
    .filter((item) => item.userComment)
    .sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt))[0]?.userComment;

  const handleReload = () => {
    setContentDataStatus(null)
    fetchProposalHalfPageUnsolicated();
    if (proposalData?.[0]?.evalStatus >= 2 && proposalData?.[0]?.evalStatus !== 10) {
      fetchCEEvalDetails();
    }
  }

  //Assign Proposal Changes
  const [isExpanded, setIsExpanded] = useState(false);
  const childRef = useRef(null);
  const [ToBeAssigned, setToBeAssigned] = useState(false)
  const [commissionEditior, setCommissionEditior] = useState([])
  const [evaluationVal, setEvaluationVal] = useState([])
  const [selectedCriteria, setSelectedCriteria] = useState([])
  const [optionalCriteriaNames, setOptionalCriteriaNames] = useState([]);

  const fetchEvaluation = async (url) => {
    try {
      const response = await fetchAPI(url);
      setEvaluationVal(response.content);
      setSelectedCriteria(response.content.map((item) => item.criteriaName))
    } catch (error) {
      console.error("Error fetching proposal:", error);
    }
  };

  const fetchSMDetails = async () => {
    try {
      const clusterId = JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"))[0].clusterId;
      const response = await fetchFilterByCretedBy(Globals.HALF_PAGE_BRIEF_DETAILS.SM_ROLE_ID, clusterId);
      const name = response?.data?.content?.map(item => item.name).join(", ") || " ";
      return name;
    } catch (error) {
      console.error("Error fetching SM Details:", error);
      const name = " ";
      return name;
    }
  };

  const fetchCommisionEditor = async (roleID, clusterId) => {
    try {
      const response = await fetchCommisionEditors(roleID, clusterId);
      setCommissionEditior(response.data.content);
    } catch (error) {
      console.error("Error fetching proposal:", error);
    }
  };

  const [clusterDetails, setClusterDetails] = useState({});
  const memoizedCluster = useMemo(() => {
    const clusters = JSON.parse(CryptoUtils.getFromLocalStorage("clusters") || "[]");
    const activeCluster = Globals.CLUSTERNAME[formatclusterandroleName(JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"))?.[0]?.clusterName)];
    const clusterId = JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"))?.[0]?.clusterId;
    setClusterDetails({
      clusterId: clusterId,
      clusterName: activeCluster
    });
    return clusters.find(cluster => cluster.clusterName === clusterName);
  }, [clusterName]);

  useEffect(() => {
    if (ToBeAssigned) {
      (memoizedCluster || clusterDetails) && fetchCommisionEditor(OldGlobals.USER_ROLES.CE, clusterDetails.clusterId);
      fetchEvaluation(OldGlobals.ENDPOINT.EVALUATION_CRITERIA);
    }
  }, [ToBeAssigned, memoizedCluster])

  const handleOptionlCriteriaName = (index, event) => {
    const optionalCriteriaName = [...optionalCriteriaNames];
    optionalCriteriaName[index] = event.target.value;
    setOptionalCriteriaNames(optionalCriteriaName);
  };
  const removeOptionlCriteriaName = (index) => {
    const newSocialLinks = optionalCriteriaNames.filter((_, i) => i !== index);
    setOptionalCriteriaNames(newSocialLinks);
  };

  const addOptionlCriteriaName = () => {
    setOptionalCriteriaNames([...optionalCriteriaNames, '']);
  };

  //dropdown changes 
  const handleClickOutside = (event) => {
    // Check if the click is outside all dropdowns
    const isClickInsideDropdown = Object.values(dropdownRefs.current).some((ref) =>
      ref?.contains(event.target)
    );
    if (!isClickInsideDropdown) {
      setDropdownState((prev) => ({ ...prev, activeDropdown: false }));
    }
  };


  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const dropdownRefs = useRef({});
  const [dropdownState, setDropdownState] = useState({
    activeDropdown: false,
    dropdowns: { selected: [], selectedText: [] },
  });

  const handletog = (value) => {
    setDropdownState((prev) => ({ ...prev, activeDropdown: !value }));
  }


  useEffect(() => {
    if (childRef.current && !dropdownState.activeDropdown) {
      childRef.current.validateField1("CommissionEditors", dropdownState.dropdowns.selected)
    }

  }, [dropdownState.activeDropdown])

  const handleSelectAll = (selectAll, options) => {
    const selectedDataSting = options.map((option) => String(option.id));
    const selectedDataText = options.map((option) => String(option.name));
    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        selected: selectAll ? selectedDataSting : [],
        selectedText: selectAll ? selectedDataText : [],
      },
    }));
  };

  const handleSelect = (value) => {
    setDropdownState((prev) => {
      const dropdown = prev.dropdowns;
      if (!dropdown) return prev;
      const isSelected = dropdown.selected.includes(String(value.id));
      const inSelectedText = dropdown.selectedText.includes(String(value.name));
      const newSelected = isSelected
        ? dropdown.selected.filter((item) => item !== String(value.id)).map(String)
        : [...dropdown.selected.filter((item) => item !== String(value.id)), String(value.id)];

      const newSelectedText = inSelectedText
        ? dropdown.selectedText.filter((item) => item !== String(value.name)).map(String)
        : [
          ...dropdown.selectedText.filter((item) => item !== String(value.name)),
          String(value.name),
        ];
      return {
        ...prev,
        dropdowns: {
          selected: newSelected,
          selectedText: newSelectedText,
        },
      };
    });
  }


  const handleChange = (event) => {
    const value = event.target.name;
    setSelectedCriteria((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };
  const ProposalProps = {
    proposalData,
    onClose,
    setIsExpanded,
    isExpanded,
    isSynopsisExpanded,
    toggleSynopsis,
    isLogLineExpanded,
    toggleLogLine,
    isepisodeStructureExpanded,
    toggleEpisode,
    islocationStudioInfoExpanded,
    toggleLocation,
    iscastPresenterInfoExpanded,
    toggleCast,
    isbrandIntegrationExpanded,
    toggleBrand,
    isprojectStatusExpanded,
    toggleProjectStatus,
    iskeyTeamsExpanded,
    toggleKeyteam,
    fileItems,
    dropdownState,
    commissionEditior,
    handletog,
    handleSelectAll,
    handleSelect,
    dropdownRefs,
    evaluationVal,
    selectedCriteria,
    handleChange,
    optionalCriteriaNames,
    handleOptionlCriteriaName,
    removeOptionlCriteriaName,
    addOptionlCriteriaName,
    roleID,
    proposalId,
    refreshDashboard,
    renderToast,
    handleBackPress,
    setToBeAssigned
  }

  useEffect(() => {
    if (proposalData?.[0]?.title || proposalData?.[0]?.projectTitle) {
      setTitle(proposalData?.[0]?.title || proposalData?.[0]?.projectTitle || "");
    }
  }, proposalData);

  const handleTitle = (title) => {
    setTitle(title);
  }

  const producerNavProps = {
    activeHeader: isAuditTrail ? 'auditTrails' : 'all_proposals',
    selectedTab: isAuditTrail ? '' : 'unSolicited',
    proposalId: item?.proposalId,
    proposalDetailId: proposalDetailIdVal,
    isFromHalfscreen: true,
    page: page
  }

  useEffect(() => {
    if (item) {
      dispatch(setUSPDetails({ selectedTableItem: item }));
    }
  }, [item])

  const verifyLatestInCEReview = (proposalHistoryId) => {
    const latestCEUpdateHistoryId = proposalData[0]?.ceStatusList?.[0]?.proposalStatusHistoryId;
    if (proposalHistoryId === latestCEUpdateHistoryId) {
      return true;
    }
    else {
      return false;
    }
  }

  return (
    <div>
      {/* Main Half Screen */}
      {ToBeAssigned ?
        <div className="proposal-Page-Content">
          <ProposalContext.Provider value={ProposalProps}>
            <AssignProposalHalfPage ref={childRef} />
          </ProposalContext.Provider>
        </div>
        : <>
          {!hideMainLayout ?
            <div className={`proposal-Page-Content ${roleID === OldGlobals.USER_ROLES.CC && item?.statusInfo?.statusEnglish === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.IN_VIRTUAL_PITCH ? 'proposal-Page-Content-hop' : ''}`}>

              <Halfpageheader proposalData={proposalData} onClose={onClose} isAssignedBrief={true} ProposalTitle={title} />

              {proposalData && proposalData?.length ? (
                <>
                  <div className='main-nav'>

                    {roleID !== Globals.USER_ROLES.PRODUCER && (
                      <div className='Download-Wrapper'>
                        <DownloadDocPdf key={title} proposalDetailId={proposalData[0]?.proposalDetailId} proposalId={proposalData[0]?.proposalId} proposalType={OldGlobals.HALFSCREEN.UNSOLICITED} proposalTitle={title} />
                      </div>
                    )}


                    <div className="HalfPage-proposal-unsolicated">
                      <div className='unsolicated-gap'>
                        <div className="proposal-details-timeline">
                          {Globals.SOLICITED_PROPOSAL.PROPOSAL_TIMELINE}
                        </div>
                        <div className="proposal-status-layout">
                          {proposalData?.[0]?.proposalStatusHistories?.length > 0 ? (
                            proposalData?.[0]?.proposalStatusHistories.sort((a, b) => new Date(a.changedAt) - new Date(b.changedAt)).map(
                              (historyItem, index) => {
                                const status = historyItem.currentStatus;
                                const changedAt = historyItem.changedAt;
                                console.log("statusTimeline", status);
                                const formattedDate = changedAt
                                  ? format(new Date(changedAt), "dd MMM yyyy")
                                  : null;
                                const imagePath = statusImg(status);
                                return (
                                  <React.Fragment
                                    key={historyItem.proposalStatusHistoryId || index}
                                  >
                                    <div className="proposal-status-item">
                                      <div className="imgtxt">
                                        {imagePath && (
                                          <img
                                            src={imagePath}
                                            alt={statusLabels[status] || OldGlobals.HALFSCREEN.STATUS_IMAGE}
                                            width={20}
                                            height={20}
                                          />
                                        )}
                                        <p className="status-txt">
                                          {statusLabels[status] || "Unknown Status"}
                                          {(statusLabels[status] === Globals.CC_UNSOLICITED_PROPOSAL_STATUS.IN_CE_REVIEW && verifyLatestInCEReview(historyItem?.proposalStatusHistoryId)) &&
                                            <CEEvalStatusToolTip title={
                                              <ul style={{ margin: 0, padding: '20px' }}>
                                                {proposalData?.[0]?.ceStatusList ? proposalData?.[0]?.ceStatusList?.sort((a, b) => a.ceName.trim().localeCompare(b.ceName.trim(), undefined, { sensitivity: 'base' }))
                                                  .map((ce, index) => (
                                                    <span key={index}>
                                                      <span>{ce.ceName} - </span>
                                                      <span style={{ color: ce.status === Globals.HALFSCREEN.STATUS.COMPLETED ? '#2B681D' : '#E0001B' }}>
                                                        {ce.status}
                                                      </span><br />
                                                    </span>
                                                  )) : Globals.NO_DATA_AVAILABLE}
                                              </ul>
                                            } direction={"top"}>
                                              <img className="infoTooltip" src={infoIcon} alt="Info Icon" />
                                            </CEEvalStatusToolTip>
                                          }
                                        </p>
                                      </div>
                                      {formattedDate && (
                                        <p className="status-date">{Globals.HALFSCREEN.TIME_ON} {formattedDate}</p>
                                      )}
                                    </div>
                                    {index <
                                      proposalData?.[0]?.proposalStatusHistories?.length -
                                      1 && (
                                        <img src={Globals.IMG.DASH} alt="" className='dash' />)}
                                  </React.Fragment>
                                );
                              }
                            )
                          ) : (
                            <p>{Globals.HALFSCREEN.NO_STATUS_HISTORY}</p>
                          )}
                        </div>
                        {proposalStatus && [3, 5, 6].includes(proposalStatus) && latestComment && (
                          <div className="status-comments">
                            <p className="unsolicated-proposal-comments">{Globals.SOLICITED_PROPOSAL.COMMENTS}</p>
                            <p className="comment-unsolicated">{latestComment}</p>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="proposal-HalfPage-pitch">
                      <ProposalContext.Provider value={ProposalProps}>
                        <ProposalDetails title={title} expanded={false} currentStatus={item?.statusInfo?.statusEnglish?.toUpperCase()} onTitlechange={handleTitle} producerNavProps={producerNavProps} />
                      </ProposalContext.Provider>
                    </div>
                    <div>
                    {
  roleID !== Globals.USER_ROLES.PRODUCER &&
  proposalData?.[0]?.evalStatus >= 1 && (
    <>
      {isAuditTrail && ((
          (proposalData?.[0]?.evalStatus !== 7 && proposalData?.[0]?.isProposalUnsuccessfulAfterCEAssign !== true)
            ||
          (proposalData?.[0]?.evalStatus === 7 && proposalData?.[0]?.isProposalUnsuccessfulAfterCEAssign === true)
        )) && (
        
        <CEEvalViewAccordion
          data={ceEvalDetails}
          _proposalId={item.proposalId}
          _proposalDeatilId={item.proposalDetailId}
          getCEEvalDetails={fetchCEEvalDetails}
           proposalStatus={proposalData?.[0]?.evalStatus}
          clusterCEList={clusteredCEList}
          existingCEList={existingCEList}
          close={onClose}
          tabName="unSolicited"
          evalStatus={proposalData?.[0]?.evalStatus}
          roleID={CryptoUtils.getFromLocalStorage('roleId')}
          ceEvalAPIFailure={ceEvalAPIFailure}
        />
      )}
                            {!isAuditTrail && (((
                              (
                                (proposalData?.[0]?.evalStatus !== 7 && proposalData?.[0]?.evalStatus !== 10)
                                ||
                                (proposalData?.[0]?.evalStatus === 10 &&
                                  proposalData?.[0]?.proposalStatusHistories[
                                    proposalData?.[0]?.proposalStatusHistories.length - 1
                                  ]?.currentStatus > 0)
                              ) &&
                              proposalData?.[0]?.isProposalUnsuccessfulAfterCEAssign !== true
                            )
                              ||
                              (
                                proposalData?.[0]?.evalStatus === 7 &&
                                proposalData?.[0]?.isProposalUnsuccessfulAfterCEAssign === true
                              )
                            )) && (

        <CEEvalViewAccordion
          data={ceEvalDetails}
          _proposalId={item.proposalId}
          _proposalDeatilId={item.proposalDetailId}
          getCEEvalDetails={fetchCEEvalDetails}
           proposalStatus={proposalData?.[0]?.evalStatus}
          clusterCEList={clusteredCEList}
          existingCEList={existingCEList}
          close={onClose}
          tabName="unSolicited"
          evalStatus={proposalData?.[0]?.evalStatus}
          roleID={CryptoUtils.getFromLocalStorage('roleId')}
          ceEvalAPIFailure={ceEvalAPIFailure}
        />
      )}
      {!isAuditTrail && (((proposalData?.[0]?.evalStatus!==7 && proposalData?.[0]?.evalStatus!==10) || (proposalData?.[0]?.evalStatus=== 10 && proposalData?.[0]?.proposalStatusHistories[proposalData?.[0]?.proposalStatusHistories.length - 1].currentStatus > 0)) && proposalData?.[0]?.isProposalUnsuccessfulAfterCEAssign===true) && (
        <CEEvalViewAccordion
          data={ceEvalDetails}
          _proposalId={item.proposalId}
          _proposalDeatilId={item.proposalDetailId}
          getCEEvalDetails={fetchCEEvalDetails}
           proposalStatus={proposalData?.[0]?.evalStatus}
          clusterCEList={clusteredCEList}
          existingCEList={existingCEList}
          close={onClose}
          tabName="unSolicited"
          evalStatus={proposalData?.[0]?.evalStatus}
          roleID={CryptoUtils.getFromLocalStorage('roleId')}
          ceEvalAPIFailure={ceEvalAPIFailure}
        />
      )}
    </>
  )}
                   
                    </div>
                  </div>
                  <div className="Half-Page-Close-Apply-Wrapper Downloadable">

                    <div className="Half-Page-Close-Apply-btn-Brief Downloadable-header" >
                      <div className="proposal-Close-Apply-btn-layout">
                        <Button
                          title={Globals.HALF_PAGE_BRIEF_DETAILS.CLOSE}
                          id="Half-Screen-Close-Btn"
                          additionalStyle="close-text proposal-Close-Apply-btn-layout"
                          action={onClose}
                        />
                      </div>
                      {(roleID === OldGlobals.USER_ROLES.CC || roleID === OldGlobals.USER_ROLES.CE) && ((item?.statusInfo?.statusEnglish?.toUpperCase() !== OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.RE_ASSIGN_REQUESTED?.toUpperCase())) &&
                        <Button
                          title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.RE_ASSIGN_PROPOSAL}
                          id="proposal-unsolicitaed-blue-btn"
                          additionalStyle="apply-button"
                          disabled={isApplyButtonDisabled}
                          action={() => {
                            setHideMainLayout(true);
                          }}
                        />}
                      {proposalData?.[0]?.status === 3 && roleID === OldGlobals.USER_ROLES.PRODUCER ? (
                        <Button
                          title="Re-work"
                          id="Half-Screen-Rework-Button"
                          additionalStyle="Re-work"
                          disabled={isApplyButtonDisabled}
                          action={() => {
                            let row = item;
                            navigate(Globals.NAVPATH.EDIT_UNSOLICITED, {
                              state: { row },
                            });
                          }}
                        />
                      ) : proposalData?.[0]?.status === 1 && roleID === OldGlobals.USER_ROLES.PRODUCER ? (
                        <Button
                          title={Globals.HALFSCREEN.STATUS.EDIT_PROPOSAL}
                          id="Half-Screen-edit-Button"
                          additionalStyle="Edit-Proposal"
                          disabled={isApplyButtonDisabled}
                          action={() => {
                            let row = item;
                            navigate(Globals.NAVPATH.EDIT_UNSOLICITED, {
                              state: { row },
                            });
                          }}
                        />
                      ) :
                        //CC Halfscreen CTA buttons rendering based on status

                        //To be assigned Status
                        (roleID === OldGlobals.USER_ROLES.CC && (item?.statusInfo?.statusEnglish?.toUpperCase() === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.TO_BE_ASSIGNED?.toUpperCase())) ?
                          <>
                            <Button
                              title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.REJECT_PROPOSAL}
                              id="half-page-cc-reject-proposal-btn"
                              additionalStyle="half-page-cc-reject-proposal-btn"
                              disabled={isApplyButtonDisabled}
                              disable={false} //HOT FIX FOR REJECT BUTTON
                              action={() => {
                                onClose()
                                popupShow?.openPopup({ isNewAcceptanceMail: false, newRejection: true, open: true, title: Globals.REJECT_PROPOSAL.TITLE, promptText: Globals.REJECT_PROPOSAL.MESSAGE, customClassName: 'email-popup-content', normalActionText: Globals.REJECT_PROPOSAL.BUTTON_TEXT, textAreaStyle: 'popup-email-text', textAreaTitle: Globals.CC_CE_COMMENTS, toastMessage: Globals.REJECT_PROPOSAL.TOAST_SUCCESS, isReject: true, body: { ...proposalBody, status: '7' } })
                              }}
                            />
                            <Button
                              title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.ASSIGN_PROPOSAL}
                              id="half-page-cc-assign-proposal-btn"
                              additionalStyle="half-page-cc-assign-proposal-btn"
                              disabled={isApplyButtonDisabled}
                              action={() => {
                                setToBeAssigned(!ToBeAssigned)
                              }}
                            />
                          </>
                          :
                          //In CE Review Status
                          (roleID === OldGlobals.USER_ROLES.CC && (item.statusName?.toUpperCase() === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.IN_CE_REVIEW?.toUpperCase() || item?.statusInfo?.statusEnglish?.toUpperCase() === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.IN_CE_REVIEW?.toUpperCase())) ?
                            <>
                              {/* <Button
                            title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.RE_ASSIGN_PROPOSAL}
                            id="half-page-cc-re-assign-proposal"
                            additionalStyle="half-page-cc-re-assign-proposal"
                            disabled={isApplyButtonDisabled}
                            action={() => {
                             
                              setHideMainLayout(true);
                            }}
                          /> */}
                            </>
                            :
                            //Invite to Virtual Pitch status
                            (roleID === OldGlobals.USER_ROLES.CC && (item.statusName?.toUpperCase() === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.INVITE_TO_VIRTUAL_PITCH?.toUpperCase() || item?.statusInfo?.statusEnglish?.toUpperCase() === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.INVITE_TO_VIRTUAL_PITCH?.toUpperCase())) ?
                              <>
                                <Button
                                  title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.INVITE_TO_VIRTUAL_PITCH}
                                  id="half-page-cc-invite-to-vp-btn"
                                  additionalStyle="half-page-cc-invite-to-vp-btn"
                                  disabled={isApplyButtonDisabled}
                                  action={() => {
                                    onClose()
                                    popupShow.openPopup({ isNewAcceptanceMail: true, open: true, title: Globals.INVITE_TO_VIRTUAL_PITCH.TITLE, promptText: Globals.INVITE_TO_VIRTUAL_PITCH.MESSAGE, customClassName: 'email-popup-content', normalActionText: Globals.INVITE_TO_VIRTUAL_PITCH.BUTTON_TEXT, textAreaStyle: 'popup-email-text', textAreaTitle: Globals.CC_CE_COMMENTS, toastMessage: Globals.INVITE_TO_VIRTUAL_PITCH.TOAST_SUCCESS, body: proposalBody, emailContent: Globals.NEW_VIRTUAL_PITCH_EMAIL_CONTENT })
                                  }}
                                />
                                {console.log("dsdsdsdsd===>", data?.[0].isVirtualPitchCompleted)}
                                {data && !data?.[0].isVirtualPitchCompleted && !data?.[0].isVirtualPitchBySM && (
                                  <>
                                    {isSMRoleAvailableInCluster&&<Button
                                      title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.ASSIGN_SM_EVALUATION}
                                      id="half-page-cc-assign-sm-eval-btn"
                                      additionalStyle="half-page-cc-assign-sm-eval-btn"
                                      disabled={isApplyButtonDisabled}
                                      action={() => {
                                        onClose()
                                        popupShow.toggleSmEvaluation({ open: true, isSmEvaluation: true, toastMessage: Globals.SM_TOAST_SUCCESS, body: { ...proposalBody, status: 4, isVirtualPitchCompleted:data?.[0].isVirtualPitchCompleted } })
                                      }}
                                    />}
                                    {isHOPRoleAvailableInCluster&&<Button
                                      title={Globals.ASSIGN_HOP_EVALUATION}
                                      id="half-page-cc-assign-hop-eval"
                                      additionalStyle="half-page-cc-assign-hop-eval"
                                      disabled={isApplyButtonDisabled}
                                      action={() => {
                                        onClose()
                                        popupShow.toggleHOPEvaluation({ open: true, isHOPEvaluation: true, toastMessage: Globals.HOP_TOAST_SUCCESS, body: { ...proposalBody, status: 11 } })
                                      }}
                                    />}
                                  </>
                                )}
                                

                              </>
                              :
                              //In Virtual Pitch status
                              (roleID === OldGlobals.USER_ROLES.CC && (item.statusName?.toUpperCase() === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.IN_VIRTUAL_PITCH?.toUpperCase() || item?.statusInfo?.statusEnglish?.toUpperCase() === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.IN_VIRTUAL_PITCH?.toUpperCase())) ?
                                <>
                                {!isUnsuccessfulMailSent && (
                                  <Button
                                    title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.UNSUCCESSFUL}
                                    id="half-page-cc-unsuccessful-proposal-btn"
                                    additionalStyle="half-page-cc-unsuccessful-proposal-btn"
                                    disabled={isApplyButtonDisabled}
                                    disable={isUnsuccessfulMailSent} //made changes based on API for mail trigger flag //HOT FIX
                                    action={() => {
                                      onClose()
                                      popupShow.openPopup({ newRejection: true, isNewAcceptanceMail: false, open: true, title: Globals.REJECTION_MAIL_VIRTUAL_PITCH.TITLE, promptText: Globals.REJECTION_MAIL_VIRTUAL_PITCH.MESSAGE, customClassName: 'reject-email-popup-content', normalActionText: Globals.REJECTION_MAIL_VIRTUAL_PITCH.BUTTON_TEXT, textAreaStyle: 'popup-email-text', textAreaTitle: Globals.CC_CE_COMMENTS, toastMessage: Globals.REJECTION_MAIL_VIRTUAL_PITCH.TOAST_SUCCESS, body: { ...proposalBody, status: '7' }, emailContent: Globals.REJECTION_MAIL_VIRTUAL_PITCH.POPUP_EMAIL_HEADER })
                                    }}
                                  />
                                )}
                                  { data && !data?.[0].isVirtualPitchBySM && (
                                    <> 
                                  {isSMRoleAvailableInCluster&&<Button
                                    title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.ASSIGN_SM_EVALUATION}
                                    id="half-page-cc-assign-sm-eval-btn"
                                    additionalStyle="half-page-cc-assign-sm-eval-btn"
                                    disabled={isApplyButtonDisabled}
                                    action={() => {
                                      onClose()
                                      popupShow.toggleSmEvaluation({ open: true, isSmEvaluation: true, toastMessage: Globals.SM_TOAST_SUCCESS, body: { ...proposalBody, status: 4 } })
                                    }}
                                  />}
                                  {/** Button for HOP Evaluation when status in In Virtual Pitch  */}
                                  {isHOPRoleAvailableInCluster&&<Button
                                    title={Globals.ASSIGN_HOP_EVALUATION}
                                    id="half-page-cc-assign-hop-eval"
                                    additionalStyle="half-page-cc-assign-hop-eval"
                                    disabled={isApplyButtonDisabled}
                                    action={() => {
                                      onClose()
                                      popupShow.toggleHOPEvaluation({ open: true, isHOPEvaluation: true, toastMessage: Globals.HOP_TOAST_SUCCESS, body: { ...proposalBody, status: 11 } })
                                    }}
                                  />}
                                  </>
                                  )}
                                  { data && data?.[0].isVirtualPitchBySM && (
                                  <Button
                                      title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.INVITE_MANAGEMENT_PITCH}
                                      id="half-page-cc-invite-management-pitch-btn"
                                      additionalStyle="half-page-cc-invite-management-pitch-btn"
                                      disabled={isApplyButtonDisabled}
                                      action={() => {
                                        onClose()
                                        popupShow.openPopup({ isNewAcceptanceMail: true, open: true, title: Globals.INVITE_TO_INMANAGEMENT_PITCH.TITLE, promptText: Globals.INVITE_TO_INMANAGEMENT_PITCH.MESSAGE, customClassName: 'email-popup-content', normalActionText: Globals.INVITE_TO_INMANAGEMENT_PITCH.BUTTON_TEXT, textAreaStyle: 'popup-email-text', textAreaTitle: Globals.CC_CE_COMMENTS, toastMessage: Globals.INVITE_TO_INMANAGEMENT_PITCH.TOAST_SUCCESS, body: {...proposalBody, status: '5'},  emailContent: Globals.NEW_IN_MANAGEMENT_PITCH_EMAIL_CONTENT })
                                      }}
                                    />
                                  )}
                                </> :
                                //Rework status
                                (roleID === OldGlobals.USER_ROLES.CC && (item.statusName?.toUpperCase() === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.REWORK?.toUpperCase() || item?.statusInfo?.statusEnglish?.toUpperCase() === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.REWORK?.toUpperCase())) ?
                                  <>
                                    {!proposalData?.[0]?.isReworkEmailSent && <Button
                                      title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.SEND_RE_WORK_MAIL}
                                      id="half-page-cc-re-work-mail-btn"
                                      additionalStyle="half-page-cc-re-work-mail-btn"
                                      disabled={isApplyButtonDisabled}
                                      action={() => {
                                        onClose()
                                        popupShow.openPopup({ isNewAcceptanceMail: true, open: true, title: Globals.RE_WORK.TITLE, promptText: Globals.RE_WORK.MESSAGE, customClassName: 'email-popup-content', normalActionText: Globals.RE_WORK.BUTTON_TEXT, textAreaStyle: 'popup-email-text', textAreaTitle: Globals.CC_CE_COMMENTS, toastMessage: Globals.RE_WORK.TOAST_SUCCESS, body: proposalBody, emailContent: Globals.NEW_REWORK_EMAIL_CONTENT })
                                      }}
                                    />}
                                  </> :
                                  //Invite to in management pitch status
                                  (roleID === OldGlobals.USER_ROLES.CC && (item.statusName?.toUpperCase() === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.INVITE_TO_MANAGEMENTS_PITCH?.toUpperCase() || item?.statusInfo?.statusEnglish?.toUpperCase() === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.INVITE_TO_MANAGEMENTS_PITCH?.toUpperCase())) ?
                                    <Button
                                      title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.INVITE_MANAGEMENT_PITCH}
                                      id="half-page-cc-invite-management-pitch-btn"
                                      additionalStyle="half-page-cc-invite-management-pitch-btn"
                                      disabled={isApplyButtonDisabled}
                                      action={() => {
                                        onClose()
                                        popupShow.openPopup({ isNewAcceptanceMail:true, open: true, title: Globals.INVITE_TO_INMANAGEMENT_PITCH.TITLE, promptText: Globals.INVITE_TO_INMANAGEMENT_PITCH.MESSAGE, customClassName: 'email-popup-content', normalActionText: Globals.INVITE_TO_INMANAGEMENT_PITCH.BUTTON_TEXT, textAreaStyle: 'popup-email-text', textAreaTitle: Globals.CC_CE_COMMENTS, toastMessage: Globals.INVITE_TO_INMANAGEMENT_PITCH.TOAST_SUCCESS, body: proposalBody, emailContent: Globals.NEW_IN_MANAGEMENT_PITCH_EMAIL_CONTENT })
                                      }}
                                    />
                                    :
                                    // IN management pitch
                                    (roleID === OldGlobals.USER_ROLES.CC && (item.statusName?.toUpperCase() === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.IN_MANAGEMENT_PITCH?.toUpperCase() || item?.statusInfo?.statusEnglish?.toUpperCase() === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.IN_MANAGEMENT_PITCH?.toUpperCase())) ?
                                      <>
                                        <Button
                                          title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.UNSUCCESSFUL}
                                          id="half-page-cc-unsuccessful-proposal-btn"
                                          additionalStyle="half-page-cc-unsuccessful-proposal-btn"
                                          disabled={isApplyButtonDisabled}
                                          disable={false} //HOT FIX
                                          action={() => {
                                            onClose()
                                            popupShow.openPopup({ newRejection: true, open: true, title: Globals.IN_MANAGEMENT_PITCH.UNSUCCESSFUL.TITLE, promptText: Globals.IN_MANAGEMENT_PITCH.UNSUCCESSFUL.MESSAGE, customClassName: 'reject-email-popup-content', normalActionText: Globals.IN_MANAGEMENT_PITCH.UNSUCCESSFUL.BUTTON_TEXT, textAreaStyle: 'popup-email-text', textAreaTitle: Globals.CC_CE_COMMENTS, toastMessage: Globals.IN_MANAGEMENT_PITCH.UNSUCCESSFUL.TOAST_SUCCESS, body: { ...proposalBody, status: 7 }, emailContent: Globals.IN_MANAGEMENT_PITCH.UNSUCCESSFUL.POPUP_EMAIL_HEADER })

                                          }}
                                        />
                                        <Button
                                          title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.ACCEPTED}
                                          id="half-page-cc-accepted-proposal-btn"
                                          additionalStyle="half-page-cc-accepted-proposal-btn"
                                          disabled={isApplyButtonDisabled}
                                          action={() => {
                                            onClose()
                                            popupShow.openPopup({ isNewAcceptanceMail: true, open: true, title: Globals.IN_MANAGEMENT_PITCH.ACCEPTED.TITLE, promptText: Globals.IN_MANAGEMENT_PITCH.ACCEPTED.MESSAGE, customClassName: 'email-popup-content', normalActionText: Globals.IN_MANAGEMENT_PITCH.ACCEPTED.BUTTON_TEXT, textAreaStyle: 'popup-email-text', textAreaTitle: Globals.CC_CE_COMMENTS, toastMessage: Globals.IN_MANAGEMENT_PITCH.ACCEPTED.TOAST_SUCCESS, body: { ...proposalBody, status: 8 }, emailContent: Globals.NEW_ACCEPTED_EMAIL_PROPS.EMAIL_CONTENT })
                                          }}
                                        />
                                      </> :
                                      //UnsuccessFul status
                                      (roleID === OldGlobals.USER_ROLES.CC && (item.statusName?.toUpperCase() === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.UNSUCCESSFUL?.toUpperCase() || item?.statusInfo?.statusEnglish?.toUpperCase() === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.UNSUCCESSFUL?.toUpperCase())) ?
                                        <>{!isUnsuccessfulMailSent&&<Button
                                          title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.SEND_MAIL}
                                          id="half-page-cc-send-mail-btn"
                                          additionalStyle="half-page-cc-send-mail-btn"
                                          disabled={isApplyButtonDisabled}
                                          disable={isUnsuccessfulMailSent} //HOT FIX
                                          action={() => {
                                            onClose()
                                            popupShow.openPopup({ newRejection: true, open: true, title: Globals.UNSUCCESSFUL.TITLE, promptText: Globals.UNSUCCESSFUL.MESSAGE, customClassName: 'reject-email-popup-content', normalActionText: Globals.UNSUCCESSFUL.BUTTON_TEXT, textAreaStyle: 'popup-email-text', textAreaTitle: Globals.CC_CE_COMMENTS, toastMessage: Globals.UNSUCCESSFUL.TOAST_SUCCESS, body: proposalBody, emailContent: Globals.UNSUCCESSFUL.POPUP_EMAIL_HEADER })
                                          }}
                                        />}
                                            {proposalData?.[0]?.isProposalUnsuccessfulAfterCEAssign === true &&
                                              <>
                                                {(!isUnsuccessfulMailSent && isHOPRoleAvailableInCluster && !isUnsuccessfulAfterSM)&&<Button
                                                  title={Globals.ASSIGN_HOP_EVALUATION}
                                                  id="half-page-cc-assign-hop-eval"
                                                  additionalStyle="half-page-cc-assign-hop-eval"
                                                  disabled={isApplyButtonDisabled}
                                                  action={() => {
                                                    onClose()
                                                    popupShow.toggleHOPEvaluation({ open: true, isHOPEvaluation: true, toastMessage: Globals.HOP_TOAST_SUCCESS, body: { ...proposalBody, status: 11 } })
                                                  }}
                                                />}
                                              {(!isUnsuccessfulMailSent && isSMRoleAvailableInCluster && !isUnsuccessfulAfterSM)&&<Button
                                                title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.ASSIGN_SM_EVALUATION}
                                                id="half-page-cc-assign-sm-eval-btn"
                                                additionalStyle="half-page-cc-assign-sm-eval-btn"
                                                disabled={isApplyButtonDisabled}
                                                action={() => {
                                                  onClose()
                                                  popupShow.toggleSmEvaluation({ open: true, isSmEvaluation: true, toastMessage: Globals.SM_TOAST_SUCCESS, body: { ...proposalBody, status: 4 } })
                                                }}
                                              />}
                                              </>
                                            }
                                        </>

                                        /*
                                        * CE Flow CTA Buttons implementation
                                        */

                                        //For Review Pending status
                                        : ((roleID === OldGlobals.USER_ROLES.CE || roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID === OldGlobals.USER_ROLES.HOP) &&
                                          item?.statusInfo?.statusEnglish?.toUpperCase() === OldGlobals.CE_PROPOSAL_STATUS.REVIEW_PENDING?.toUpperCase()) ?
                                          <>
                                          {console.log("saasas====>",data?.[0])}
                                            <Button
                                              title={Globals.CE_STATUS_BTN_TITLES.REVIEW_PROPOSAL}
                                              id="half-page-ce-review-proposal"
                                              additionalStyle="half-page-ce-review-proposal"
                                              disabled={isApplyButtonDisabled}
                                              action={() => {
                                                navigateToPage()
                                              }}
                                            />
                                          </>
                                          : null}
                    </div>
                  </div>
                </>
              ) : contentDataStatus && contentDataStatus?.length > 0 ? (
                <>
                  <NoResultsComponent
                    data={{
                      message: Globals.HALF_PAGE_MESSAGE,
                      img: Globals.IMG.HALF_PAGE_ERROR,
                      submessage: Globals.HALF_PAGE_SUB_MESSAGE,
                      className: "ErrorHeader",
                      subclassName: "SubError",
                      outerWrapper: "HalfPageWrapper",
                      button: "reload",
                    }}
                    handleReload={handleReload}
                  />
                </>
              ) : (
                <div className="NoResultsComponent" style={{ height: "80vh" }}>
                  <Loader height={50} width={50} />
                </div>
              )}
            </div>
            : (

              !hidehalfscreen &&
              <div>
                <div className="Half-Page-Content">
                  <div className="Half-Page-Header-Wrapper">
                    <div id="hp_brief_back_arrow" className="hp_brief_back_arrow"><img className="cross-mark" src={Globals.IMG.LEFT_ARROW} alt="close" onClick={handleBackPress} /></div>

                    {data && data?.length > 0 &&
                      <div className='Half-page-breif-header'>{`${data?.[0]?.bRefNo} ${" "} ${data?.[0]?.channelName} ${data?.[0]?.countryName} - ${data?.[0]?.formatName}`}</div>
                    }
                    <span className="HalfPage-close-icon HalfPage-close-icon-brief" onClick={onClose}>
                      &times;
                    </span>

                  </div>

                  {data && data?.length > 0 ? <>
                    <div className='intenalhalf-page-brief'>
                      {/* <div className="HalfPage-pitch1 uncolic" key={0}>
                    <div
                        draggable
                        className='draggable-proposal-unsolicited dddd'
                        onDragStart={(e) => e.preventDefault()}
                        onClick={() => handleToggle("brief-details", 0)}
                      >
                        <div className='half-page-sub-headr-title'>
                          <p className="unsolicited-sub-header-title">{Globals.HALF_PAGE_BRIEF_DETAILS.BRIEF_DETAILS_HEADER}</p>
                        </div>
                        <div className='half-pach-pitch1-image'>
                          <img
                            src={activeIndexes["brief-details"]?.[0] ? Globals.IMG.ARROW_UP : Globals.IMG.ARROW_DOWN}
                            alt="toggle icon"
                            className="drop_down_icon"
                          />
                        </div>

                      </div>
                      {activeIndexes["brief-details"]?.[0] && (
                        <div>

                          { }
                          {contentData?.map(
                            (item, index) =>
                              Object.values(item)[0] && (
                                <div key={index} className="Half-Page-Content-Wrapper">
                                  <div className={`${Object.keys(item)[0] === 'Description' ? 'description-heading' : 'small-heading'} Unsolicited-Half-Page-Desc-Header`}>
                                    {Object.keys(item)[0]}
                                  </div>
                                  <p className="Half-Page-Description">
                                    {Object.values(item)[0]}
                                  </p>
                                </div>
                              )
                          )}
                          <div>
                            <div className="Half-Page-Form">
                              {BreifData?.map((item, index) => (
                                <div key={index} className="Half-Page-Form-Fields" >
                                  <div className="Half-Page-Form-fields-Bold" style={{ whiteSpace: 'pre-line' }}>
                                    {item.name}
                                  </div>
                                  <div className="Half-Page-Form-Description">
                                    {item.description}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}

                    </div> */}

                      {/* Cluster portion */}
                      <div className="HalfPage-pitch1">
                        <div key={0} className="Half-Page-Content-Wrapper">
                          <div className="Half-Page-Desc-header">
                            {Globals.HALF_PAGE_BRIEF_DETAILS.CURRENT_CLUSTER}
                          </div>
                        </div>

                        <div>
                          <div className="Half-Page-Form">

                            <div key={0} className="Half-Page-Form-Fields">

                              <div className="Half-Page-Form-fields-Bold">
                                {Globals.HALF_PAGE_BRIEF_DETAILS.CLUSTER}
                              </div>
                              <div className="Half-Page-Form-Description">
                                {clusterValue.description}
                              </div>

                            </div>
                            <div key={1} className="Half-Page-Form-Fields">

                              <div className="Half-Page-Form-fields-Bold">
                                {Globals.HALF_PAGE_BRIEF_DETAILS.CHANNEL}
                              </div>
                              <div className="Half-Page-Form-Description">
                                {proposalData[0]?.channelName}
                              </div>

                            </div>

                          </div>

                        </div>

                      </div>

                      <div className="HalfPage-pitch1">
                        <div key={0} className="Half-Page-Content-Wrapper">
                          <div className="Half-Page-Desc-header">
                            {Globals.HALF_PAGE_BRIEF_DETAILS.RE_ASSIGN_TO_NEW_CLUSTER}
                          </div>
                        </div>
                        { }

                        <div>
                          <div className="Unsolicited-Half-Page-Form-Cluster-Layout">

                            <div key={0} className="Half-Page-Form-Fields">

                              <div className="Half-Page-Form-fields-Bold">
                                <div className='Unsolicited-Half-Page-Clsuter-Title-Style'>
                                  {Globals.HALF_PAGE_BRIEF_DETAILS.CLUSTER}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>
                                  <div id="row-content" className="Unsolicited-Half-Page-Cluster-Dropdown-Layout">
                                    <div id="cluster-holder">

                                      <span tabIndex={7}><DropdownList options={cluster} onSelect={handleClustersList} placeHolderValue={Globals.HALF_PAGE_BRIEF_DETAILS.SELECT_CLUSTER} selectClass={true && "hightlight" && "dropdown_internal_halfscreen"} /></span>
                                      {clusterError.error && <div><img src={Globals.IMG.ERROR} alt="password error" /><span className="invalidDataError">{clusterError.msg}</span></div>}
                                    </div>

                                  </div>
                                </div>
                                {hideMainLayout && isClusterChannelVisible ?
                                  <div className='title-style'>
                                    {Globals.HALF_PAGE_BRIEF_DETAILS.CHANNEL}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>
                                    <div id="row-content" className="Unsolicited-Half-Page-Cluster-Dropdown-Layout">
                                      <div id="cluster-holder">
                                        <span tabIndex={8}><DropdownList valueToReset={cluster} options={channelsArray} onSelect={handleChannelList} placeHolderValue={Globals.HALF_PAGE_BRIEF_DETAILS.SELECT_CHANNEL} selectClass={true && "hightlight" && "dropdown_internal_halfscreen"} /></span>
                                        {channelError.error && <div><img src={Globals.IMG.ERROR} alt="password error" /><span className="invalidDataError">{channelError.msg}</span></div>}

                                      </div>

                                    </div>
                                  </div>
                                  : <></>}
                              </div>


                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="Half-Page-Close-Apply-Wrapper">
                      <div className="Half-Page-Close-Apply-Brief">
                        <div>
                          <Button
                            title={Globals.HALF_PAGE_BRIEF_DETAILS.CLOSE}
                            id="Half-Screen-Close-Btn"
                            additionalStyle="close-text"
                            action={onClose}
                          />
                        </div>
                        <Button
                          title={Globals.HALF_PAGE_BRIEF_DETAILS.RE_ASSIGN_PROPOSAL}
                          id="Half-Screen-diable-Proposal-Button1"
                          additionalStyle={btnClassName}
                          disable={isReAssignBtnDisabled}
                          onClick={() => {
                            openPopUp("Submit");
                          }}
                          action={async () => {
                            const smRoleName = await fetchSMDetails();
                            if (smRoleName) {
                              openPopUp("Submit", false, smRoleName)
                            } else {
                              openPopUp("Submit")
                            }

                          }}
                        />
                      </div>
                    </div>


                  </> : contentDataStatus && contentDataStatus?.length > 0 ? <>
                    <div className="No-Results-Wrapper"><NoResultsComponent
                      data={{
                        message: Globals.HALF_PAGE_MESSAGE,
                        img: Globals.IMG.HALF_PAGE_ERROR,
                        submessage: Globals.HALF_PAGE_SUB_MESSAGE,
                        className: "ErrorHeader",
                        subclassName: "SubError",
                        outerWrapper: "HalfPageWrapperHalfPageBrief",
                        imgWrapper: "HalfPageBriefImg",
                        button: 'reload'
                      }}
                      handleReload={handleReload}
                    />
                    </div>
                    <div className="Half-Page-Close-Apply-Wrapper sb">
                      <div className="Half-Page-Close-Apply-Brief">
                        <div>
                          <Button
                            title={Globals.HALF_PAGE_BRIEF_DETAILS.CLOSE}
                            id="Half-Screen-Close-Btn"
                            additionalStyle="close-text"
                            action={onClose}
                          />
                        </div>
                      </div>
                    </div>
                  </> : <div className="NoResultsComponent" style={{ height: "80vh" }}>
                    <Loader height={50} width={50} />
                  </div>}

                </div>
              </div>
            )
          }
        </>
      }
    </div>
  );
}
export const useProposalContext = () => useContext(ProposalContext)